import type { Route } from "@daytrip/legacy-models";

export const extractDirectionsFromRoute = (route: Route | undefined) => ({
    firstDirection: `${route?.originLocationMachineName}-to-${route?.destinationLocationMachineName}`,
    secondDirection: `${route?.destinationLocationMachineName}-to-${route?.originLocationMachineName}`,
});
